<cheelee-responsive-layout [displayNavBar]="isDesktop()" onePage>
  <div class="media"  [style.padding-top]="isDesktop() ? headerHeight() + 'px' : 0">
    @if (mediaItem()) {
      <cheelee-media-swiper
        [isNavBarDisplayed]="false"
        [feed]="mediaForSwiper()"
        [mode]="MediaActionsMode.SINGLE"
      />
    }
    @if (mediaIsLoading() && !mediaItem()) {
      <cheelee-loader class="media__loader"/>
    }
  </div>
</cheelee-responsive-layout>
